<template>
  <v-col :cols="block.cols" :xs="block.colsxs" :sm="block.colssm" :md="block.colsmd" :lg="block.colslg" :xl="block.colsxl" :offset="block.offset">
    <v-row v-if="block.amountChangable !== false" align="center">
      <v-col v-if="block.inputLabel" cols="3" lg="2" class="text-h7 font-weight-medium">
        {{ block.inputLabel }}
      </v-col>
      <v-col cols="4" lg="2">
        <v-text-field
          v-model="counter"
          dense
          filled
          label="Anzahl"
          type="number"
          hide-details="auto"
          min="0"
        />
      </v-col>
      <v-col v-if="block.comment" cols="6" v-html="block.comment" />
    </v-row>

    <v-row
      v-for="n in parseInt(counter)"
      :key="block.uid + '_' + (n-1)"
      class="pt-6 pr-2"
      :no-gutters="block.gutters"
    >
      <template v-for="rowBlock in block.rowComponents">
        <component :is="rowBlock.component" :key="block.uid + '_' + (n-1) + '_' + rowBlock.uid" v-model="form[(n-1)][rowBlock.uid]" :block="rowBlock" />
      </template>
      <v-col v-if="n != parseInt(counter)" cols="12">
        <v-divider class="mt-2" />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { isEqual } from 'lodash'
export default {
   name: 'NInputrows',
   inject: {
      count: {
         default: () => false
      }
   },
   model: {
      prop: 'form',
      event: 'update:form'
   },

   props: {
      block: {
         type: Object,
         required: true,
      },
      form: {
         type: Array,
         required: true,
      },
   },
   data () {
      return {
         panels: [],
         counter: 0,
      }
   },

   watch: {
      counter: function (val, oldVal) {
         console.log(val)
         console.log(oldVal)
         console.log(this.form)
         console.log(this.block.default)
         console.log(JSON.parse(JSON.stringify(this.block.default)))
         val = parseInt(val)
         oldVal = (parseInt(oldVal) === this.form.length) ? parseInt(oldVal) : this.form.length
         if (val === 0) {
            this.form = []
         } else {
            if (oldVal > val) {
               this.form = this.form.slice(0, val)
            } else {
               for (let index = oldVal; index < val; index++) {
                  this.form.push(JSON.parse(JSON.stringify(this.block.default)))
               }
            }
         }
      },
      form: {
         deep: true,
         handler (val, oldVal) {
            this.$emit('update:form', this.form)
         }
      }
   },
   created () {
      console.log(this.form)
      if (this.block.optional) {
         this.block.inputLabel += ' (optional)'
         if (isEqual(this.form, this.block.default)) {
            this.form = []
         }
      }
      if (this.count && this.count instanceof Function) {
         if (this.form.length < this.count() && this.block.amountChangable === false) {
            for (let i = this.form.length; i < this.count(); i++) {
               this.form.push(JSON.parse(JSON.stringify(this.block.default)))
            }
         }
      }

      this.counter = this.form.length
      console.log(this.form)
      console.log(this.counter)
   },
}
</script>
